import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import ChipsHelper from '@/Utility/ChipsHelper';

export default class ChipsColumnFactory extends ColumnFactory {

    public static isPlainText = true;
    public static isJQueryElement = false;

    constructor(params: any) {
        super(params);
    }

    public getValue(): any {
        return ChipsHelper.getValuesAsLabel(this.raw, '; ');
    }
}

ComponentManager.setFactory('ChipsColumn', ChipsColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');